import React from 'react';

import { Box, FormControl, TextField, Typography } from '@mui/material';

import { StlPopup } from 'features/common/StlPopup/StlPopup';
import { background_input_dark } from 'theme/cemTheme';

import styles from './EditPopup.module.css';

interface EditPopupProps {
  isOpen: boolean;
  title: string;
  setIsOpen: (val: boolean) => void;
  onApply: () => void;
  subtitle?: string;
  btnTxt?: string;
  txtField?: {
    label?: string;
    value: string;
    onChange: (value: string) => void;
    maxLength?: number;
    errorMsg?: string;
  };
}

export function EditPopup({
  isOpen,
  setIsOpen,
  onApply,
  title,
  subtitle,
  btnTxt,
  txtField,
}: EditPopupProps) {
  const { label, maxLength, value, onChange, errorMsg } = txtField;
  const handleClose = () => setIsOpen(false);

  return (
    <StlPopup
      title={title}
      isOpen={isOpen}
      onClose={handleClose}
      onApply={onApply}
      disabled={!!errorMsg}
      btnTxt={btnTxt}
      sx={{ minWidth: '30rem' }}
    >
      <FormControl fullWidth>
        {subtitle && (
          <Typography variant="caption" gutterBottom>
            {subtitle}
          </Typography>
        )}

        {txtField && (
          <Box mt={1} className={styles.edit_box}>
            {label && (
              <Typography variant="body2" fontWeight={500}>
                {label}
              </Typography>
            )}
            <TextField
              inputProps={{
                maxLength,
                sx: {
                  fontSize: '0.8rem',
                  backgroundColor: background_input_dark,
                },
              }}
              variant="outlined"
              fullWidth
              value={value}
              size="small"
              margin="dense"
              onChange={(e) => onChange(e.target.value)}
              error={!!errorMsg}
              helperText={errorMsg}
            />
          </Box>
        )}
      </FormControl>
    </StlPopup>
  );
}
